module.exports = new __parcel__URL__("form-permission-onboarding.ff1f6e21.svg").toString();